import { Action, createReducer, on } from '@ngrx/store';
import { UserAction } from './action-types';
import { UserState } from './user.state';
import * as lodash from "lodash"

export const userInitialState: UserState = { isLoaded: false, profile: undefined }

const userReducer = createReducer(
    userInitialState,
    on(UserAction.userLoaded, (state, { profile }) => ({
        isLoaded: true,
        profile: profile
    })),
    on(UserAction.offloadUser, _ => userInitialState),
    // on(UserAction.updateUserProperties, (state, { properties, version }) => ({
    //     ...state,
    //     profile: {
    //         ...state.profile!,
    //         properties: properties,
    //         version: version
    //     }
    // })),
    // on(UserAction.updateUserProperty, (state, { property }) => (
    //     {
    //         ...state,
    //         profile: {
    //             ...state.profile!,
    //             properties: lodash.cloneDeep(state.profile?.properties)!.splice(state.profile?.properties!.findIndex((p) => p.name == property.name)!, 1, property)!
    //         }
    //     }))
);

export function reducer(state: UserState | undefined, action: Action) {
    return userReducer(state, action);
}